import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["categorySelect", "taxable", "overrideExpiration", "expirationMonthsGroup", "expirationMonthsInput"];

  connect() {
    // dispatch native events
    $(this.categorySelectTarget).on('select2:select', function () {
      let event = new Event('change', { bubbles: true }) // fire a native event
      this.dispatchEvent(event);
    });

    this.updateFormContent();
    this.updateExpirationFields();
  }

  updateFormContent() {
    // reset
    $('*[class*="hide-when"]').removeClass('d-none');
    $('*[class*="d-when"]').addClass('d-none');
    // change the display/none class according to the rule.
    $(`.hide-when-${this.categorySelectTarget.value}`).addClass("d-none");
    $(`.d-when-${this.categorySelectTarget.value}`).removeClass("d-none");

    // only for the taxable to be checked when it's physical_product
    if (this.categorySelectTarget.value === "physical_product") {
      this.taxableTarget.checked = 'checked';
    } else {
      this.taxableTarget.checked = undefined;
    }
  }

  updateExpirationFields() {
    if (this.hasOverrideExpirationTarget) {
      this.overrideExpirationTarget.addEventListener('change', () => {
        this.toggleExpirationInput();
      });
      this.toggleExpirationInput(); // Initialize on page load
    }
  }

  toggleExpirationInput() {
    if (this.overrideExpirationTarget.checked) {
      this.expirationMonthsGroupTarget.style.display = 'block';
      this.expirationMonthsInputTarget.disabled = false;
      this.expirationMonthsInputTarget.focus();
    } else {
      this.expirationMonthsGroupTarget.style.display = 'none';
      this.expirationMonthsInputTarget.disabled = true;
      this.expirationMonthsInputTarget.value = '';
    }
  }
}